import { VestigingStatus, vestigingStatusMap } from "@/entities/vestiging";
import { ActionsDropdown, Badge, DropdownMenuItem, Helptext, Icon, Tooltip, TooltipContent, TooltipTrigger } from "@/shared/components";
import { cn } from "@/shared/utils";

type Action = {
    label: string;
    enabled: boolean;
    action: () => void;
};

type LandelijkeFaciliteitenRowProps = {
    status: VestigingStatus | undefined;
    toelichting: string | undefined;
    actions?: Action[];
};

export function LandelijkeFaciliteitenRow({ status, toelichting, actions }: LandelijkeFaciliteitenRowProps) {
    if (!status) {
        return (
            <div className="grid grid-cols-[1fr_150px] items-center gap-x-4 py-2">
                <Helptext>Er is geen aanvraag voor landelijke faciliteiten gedaan</Helptext>
            </div>
        );
    }

    const aanvraagStatus = vestigingStatusMap[status];

    const visibleActions = actions?.filter((a) => a.enabled) ?? [];
    const hasActions = visibleActions.length > 0;

    return (
        <div className={cn("grid grid-cols-[1fr_150px] items-center gap-x-4 py-2", hasActions && "grid-cols-[1fr_150px_24px]")}>
            <div className="flex flex-row gap-2">
                <span className="text-m leading-l font-medium">Landelijke faciliteiten</span>
                <Icon name="more-ns" alt="NS logo" className="text-content-emphasis" />
            </div>
            <span className="flex flex-row items-center gap-4 justify-self-end">
                {toelichting && (
                    <Tooltip>
                        <TooltipTrigger asChild>
                            <Icon name="comment" size="m" className="text-content-emphasis" />
                        </TooltipTrigger>
                        <TooltipContent>{toelichting}</TooltipContent>
                    </Tooltip>
                )}
                <Badge
                    className="w-min justify-self-end"
                    variant={aanvraagStatus.badgeVariant}
                    data-testid="landelijke-faciliteiten-status"
                >
                    {aanvraagStatus.label}
                </Badge>
            </span>
            {hasActions && (
                <ActionsDropdown>
                    {visibleActions.map(({ action, label }) => {
                        return (
                            <DropdownMenuItem key={label} onSelect={action}>
                                {label}
                            </DropdownMenuItem>
                        );
                    })}
                </ActionsDropdown>
            )}
        </div>
    );
}
